import { render, staticRenderFns } from "./Bienvenido.vue?vue&type=template&id=71a9c4ed&scoped=true&"
import script from "./Bienvenido.vue?vue&type=script&lang=js&"
export * from "./Bienvenido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9c4ed",
  null
  
)

export default component.exports